import axios from 'axios';

/**
 * Validates that the supplied email conforms to the portal's email conformity requirements.
 * 
 * @param {string} email 
 */
 export async function validateEmail(email) {

    const config = {
        method: 'POST',
        url: '/public/user-registration/validation/validate-email',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            email: email
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

/**
 * Retrieves an automatically generated username based on the supplied email and username.
 * 
 * @param {string} email 
 * @param {string} username 
 */
export async function getAutoGeneratedUsername(email, username) {

    const config = {
        method: 'POST',
        url: '/public/user-registration/validation/populate-username',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            email: email,
            username: username
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

/**
 * Validates that a username is available for use. This includes above all validating with the 
 * server that the username has not already been reserved for usage by an existing user.
 * 
 * @param {string} username 
 */
export async function validateUsername(username) {

    const config = {
        method: 'POST',
        url: '/public/user-registration/validation/validate-username',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            username: username
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

/**
 * Validates that the email is in the correct format for the Unified User service.
 *
 * @param {string} email
 */
export async function validateUnifiedUserEmailFormat(email) {

    const config = {
        method: 'POST',
        url: '/public/user-registration/validation/validate-unified-user-email-format',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            email: email
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}

/**
 * Validates that a password conforms to the portal's password requirement rules.
 * 
 * @param {string} password 
 */
export async function validatePassword(password) {

    const config = {
        method: 'POST',
        url: '/public/user-registration/validation/validate-password',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            password: password
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });
    
}